<template>
  <header class="app-shell-header">
    <div class="app-shell-header__brand">
      <slot name="brand"></slot>
    </div>
    <div class="app-shell-header__center">
      <slot name="center"></slot>
    </div>
    <div class="app-shell-header__actions">
      <slot name="actions"></slot>
    </div>
  </header>
</template>

<style lang="scss" scoped>
.app-shell-header {
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 100%;
  width: 100%;
  box-sizing: border-box;
  padding: 0 12px;
  gap: 16px;
  background-color: $color-white;
  box-shadow: 0px 1px 5px rgba($color-gray1000, 0.25);
}

.app-shell-header__brand {
  display: flex;
  align-items: center;
  flex-shrink: 0;
}

.app-shell-header__center {
  display: flex;
  align-items: center;
  flex-grow: 1;
  min-width: 0;
}

.app-shell-header__actions {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  flex-shrink: 0;
  gap: 16px;
}
</style>
